/* tabs */
/*--------------------------------------------------------------------------------*/
const ignore: string[] = ['camera', 'drawer', 'modal'];
const hashIgnore = (hash: string) => ignore.includes(hash);
/*--------------------------------------------------------------------------------*/
export const init = (
    tabs: HTMLElement,
    onChange: (index: number, done: () => void) => void,
) => {
    const tbtn = tabs.querySelectorAll<HTMLButtonElement>('.tabs-btn');
    tbtn.forEach(elm => {
        const dataHash = elm.getAttribute('data-hash');
        elm.onclick = () => window.location.replace('#' + dataHash);
    });
    // tabs change
    const tabsChange = () => {
        const hash = (window.location.hash).replaceAll('#', '');
        if (hashIgnore(hash)) return;
        if (hash == '') {
            const mainTabs = tbtn[0].getAttribute('data-hash');
            window.location.replace('#' + mainTabs);
            return;
        }
        const curTabs = tabs.querySelector<HTMLButtonElement>('.tabs-btn.active');
        if (hash == curTabs?.getAttribute('data-hash')) return;
        // set active
        let index = 0;
        tbtn.forEach((elm, i) => {
            const dataHash = elm.getAttribute('data-hash');
            if (hash == dataHash) {
                elm.classList.add('active');
                index = i;
            } else {
                elm.classList.remove('active');
            }
        });
        loading(tabs, index);
        onChange(index, () => ready(tabs, index));
    };
    tabsChange();
    window.onhashchange = tabsChange;
};
/*--------------------------------------------------------------------------------*/
export const loading = (tabs: HTMLElement, index: number) => {
    const tbtn = tabs.querySelectorAll<HTMLButtonElement>('.tabs-btn')[index];
    const body = tabs.querySelector<HTMLElement>('.tabs-body');
    const inner = tbtn.querySelectorAll<HTMLElement>('*');
    const tabsBar = tabs.querySelector<HTMLElement>('.tabs-bar');
    if (tbtn && body) {
        // clear loader
        tabs.querySelector<HTMLElement>('.tabs-overlay')?.remove();
        tbtn.querySelector<HTMLElement>('.btn-loader')?.remove();
        // hide inner
        body.style.display = 'none';
        inner.forEach(el => el.style.display = 'none');
        // create overlay
        const overlay = document.createElement('div');
        overlay.className = 'tabs-overlay';
        tabs.appendChild(overlay);
        // create loader
        const loader = document.createElement('div');
        loader.className = 'btn-loader';
        loader.innerHTML = `<div class="spinner s24"></div>`;
        tbtn.appendChild(loader);
        // tabs-bar
        if (tabsBar) {
            const barCont = tabsBar.querySelectorAll<HTMLElement>('*');
            barCont.forEach(el => el.style.visibility = 'hidden');
            tabsBar.querySelector<HTMLElement>('.lds-ellipsis')?.remove();
            // create loader
            const loader = document.createElement('div');
            loader.className = 'lds-ellipsis';
            loader.innerHTML = `<div></div><div></div><div></div><div></div>`;
            tabsBar.prepend(loader);
        }
    }
};
/*--------------------------------------------------------------------------------*/
export const ready = (tabs: HTMLElement, index: number) => {
    const tbtn = tabs.querySelectorAll<HTMLButtonElement>('.tabs-btn')[index];
    const body = tabs.querySelector<HTMLElement>('.tabs-body');
    const inner = tbtn.querySelectorAll<HTMLElement>('*');
    const tabsBar = tabs.querySelector<HTMLElement>('.tabs-bar');
    if (tbtn && body) new Promise(r => setTimeout(r, 400)).then(() => {
        // clear loader
        tabs.querySelector<HTMLElement>('.tabs-overlay')?.remove();
        tbtn.querySelector<HTMLElement>('.btn-loader')?.remove();
        // show inner
        body.style.display = 'block';
        inner.forEach(el => el.style.display = '');
        // tabs-bar
        if (tabsBar) {
            const barCont = tabsBar.querySelectorAll<HTMLElement>('*');
            barCont.forEach(el => el.style.visibility = '');
            tabsBar.querySelector<HTMLElement>('.lds-ellipsis')?.remove();
        }
    });
};
/*--------------------------------------------------------------------------------*/
export const setActive = (tbtn: NodeListOf<HTMLButtonElement>, index: number) => {
    tbtn.forEach((elm, i) => {
        if (i == index) {
            elm.classList.add('active');
        } else {
            elm.classList.remove('active');
        }
    });
};
/*--------------------------------------------------------------------------------*/
